import { Permission } from '../types/permissions';
import { api } from './api';

class PermissionService {
  async getPermissions(): Promise<Permission[]> {
    const response = await api.get('/permissions');
    return response.data;
  }

  async getInactivePermissions(): Promise<Permission[]> {
    const response = await api.get('/permissions/inactive');
    return response.data;
  }

  async getAdminPermissions(): Promise<Permission[]> {
    const response = await api.get('/permissions/admin');
    return response.data;
  }

  async getDocumentPermissions(): Promise<Permission[]> {
    const response = await api.get('/permissions/documents');
    return response.data;
  }

  async getPermissionById(id: string): Promise<Permission> {
    const response = await api.get(`/permissions/${id}`);
    return response.data;
  }

  async createPermission(permission: Omit<Permission, 'id'>): Promise<Permission> {
    const response = await api.post('/permissions', permission);
    return response.data;
  }

  async updatePermission(id: string, permission: Partial<Permission>): Promise<Permission> {
    const response = await api.put(`/permissions/${id}`, permission);
    return response.data;
  }

  async deletePermission(id: string): Promise<void> {
    await api.delete(`/permissions/${id}`);
  }
}

export const permissionService = new PermissionService(); 
